import React, { useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ReportTicket from "../history/deliveries/ReportTicket";
import { getShippingRoutesHistoryReport } from "../../api/shipping";
import { getWorkShifts } from "../../api/workShift";
import { createDateFromTimeString } from "../../utils/dates";
import Divider from "@mui/material/Divider";

const DriversReportDialog = ({ open, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [reportOptions, setReportOptions] = useState([]);
  const [reportData, setReportData] = useState(null);
  const [showReport, setShowReport] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState(null);

  useEffect(() => {
    if (open) {
      loadReportOptions();
    }
  }, [open]);

  const loadReportOptions = async () => {
    try {
      setLoading(true);
      const { data } = await getWorkShifts();
      setReportOptions(data);
    } catch (error) {
      console.error("Error loading report options:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleOptionClick = async (shift) => {
    try {
      setLoading(true);

      const dateStart = createDateFromTimeString(shift.start_time);
      const dateEnd = createDateFromTimeString(shift.end_time);

      const filters = {
        dateStart,
        dateEnd,
        start_date: dateStart,
        end_date: dateEnd,
      };

      setSelectedFilters(filters);
      const response = await getShippingRoutesHistoryReport(filters);
      setReportData(response.data);
      setShowReport(true);
    } catch (error) {
      console.error("Error generating report:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setShowReport(false);
    setReportData(null);
    setSelectedFilters(null);
    onClose();
  };

  if (showReport && reportData) {
    return (
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: { width: "400px", maxWidth: "400px" },
        }}
      >
        <ReportTicket
          filters={selectedFilters}
          data={{
            summary: reportData.summary,
            drivers: reportData.drivers,
          }}
          emissionDate={new Date()}
        />
      </Dialog>
    );
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: { width: "400px", maxWidth: "400px" },
      }}
    >
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Selecione o Período do Relatório</Typography>
          <IconButton onClick={handleClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        {loading ? (
          <Box display="flex" justifyContent="center" p={3}>
            <CircularProgress />
          </Box>
        ) : (
          <List>
            {reportOptions.map((option, index) => (
              <>
                <ListItem key={index}>
                  <ListItemButton onClick={() => handleOptionClick(option)}>
                    <ListItemText
                      primary={option.name}
                      secondary={`${option.start_time} - ${option.end_time}`}
                    />
                  </ListItemButton>
                </ListItem>
                <Divider />
              </>
            ))}
          </List>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default DriversReportDialog;
